export default "__VITE_ASSET__B0nDsA$C__"